// Shared color tokens for the Storyboard's Connected canvas -- the exact
// app-wide values already unified this session across MainSidebar.jsx/
// FileTabs.jsx/EditorToolbar.jsx/TrackDropdown.jsx (bg/border/fg/muted/
// tabAct), plus a few board-specific extras (canvas fill, grid line, shot
// connector line, sticky-note card colors). One definition instead of each
// board component keeping its own separate `c = isDarkMode ? {...} : {...}`.
export function boardTokens(isDarkMode) {
  return isDarkMode
    ? {
        bg: '#0a0a0a', fg: '#e8e8e8', muted: '#555', border: '#1e1e1e',
        tabAct: 'rgba(255,255,255,0.12)',
        // Matches BoardsHub.jsx's Storyboard/Beatsheet ViewModeToggle track
        // color exactly -- was a separate '#161616' before, a visible
        // mismatch against that toggle sitting right above this canvas.
        canvasBg: '#141414', gridLine: 'rgba(255,255,255,0.06)',
        connector: 'rgba(232,232,232,0.55)', connectorDim: 'rgba(232,232,232,0.3)',
        stickyShadow: '0 6px 16px rgba(0,0,0,0.55)',
      }
    : {
        bg: '#f0ede5', fg: '#1a1a1a', muted: '#aaa', border: '#e0ddd4',
        tabAct: 'rgba(0,0,0,0.09)',
        canvasBg: '#e5e2da', gridLine: 'rgba(0,0,0,0.06)',
        connector: 'rgba(26,26,26,0.5)', connectorDim: 'rgba(26,26,26,0.28)',
        stickyShadow: '0 6px 16px rgba(0,0,0,0.18)',
      };
}

// Sticky-note yellow is a deliberate, scoped exception to the app's strict
// black/white base (same precedent as the green/blue/red status-badge trio
// used elsewhere) -- fixed regardless of dark/light mode, matching the
// approved mockup.
export const STICKY = {
  bg: '#fde68a',
  border: '#eab308',
  mount: '#fffbeb',
  text: '#1a1a1a',
  dim: '#78716c',
};

// Deterministic small tilt per shot id (not random per render, not
// draggable-repositioned in this pass) -- purely the "pinned to a
// corkboard" visual read from the approved mockup.
export function shotTilt(shotId) {
  let hash = 0;
  for (let i = 0; i < shotId.length; i++) hash = (hash * 31 + shotId.charCodeAt(i)) | 0;
  return ((hash % 5) - 2) * 0.8; // -1.6deg .. 1.6deg
}
